<template>
  <div class="col-lg-12">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title" >통계관리<div class="sub_title" >통계관리 → 매출</div></h5>
          <h6 style="text-align:left; margin-top:10px; ">

          </h6>



<!-- Modal -->
<div class="modal fade bd-example-modal-lg" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        ...
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

      </div>
    </div>
  </div>
</div>
<table class="table">
  <tr>
    <td>
      선택검색
    </td>
    <td>
      <input type="text" placeholder="선택박스" />
    </td>
    <td>
      <button class="btn btn-success btn-sm">매출액 엑셀저장</button>
    </td>
  </tr>

</table>
<div class="row">
  <div class="col-md-6 col-xl-3">
    <div style="text-align:right; padding:2px 10px;">전일대비 <span style="color:#cc0002;">▲ 5%</span></div>
    <div class="card mb-3 widget-content bg-grow-early" style="padding:20px; background:#444;">
      <div class="widget-content-wrapper text-white">
        <div class="widget-content-left" style="float:left;">
          <div class="widget-heading" style="font-size:26px;">2건</div>
        </div>
        <div class="widget-content-right" style="position:absolute; right:20px;font-size:30px; top:8px; line-height:60px;">
          <div class="widget-numbers text-white"><span style="font-size:30px;font-weight:bold;">4,000,000원</span></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 col-xl-3">
    <div style="text-align:right; padding:2px 10px;">전주대비 <span style="color:#cc0002;">▲ 5%</span></div>
    <div class="card mb-3 widget-content bg-grow-early" style="padding:20px; background:#444;">
      <div class="widget-content-wrapper text-white">
        <div class="widget-content-left" style="float:left;">
          <div class="widget-heading" style="font-size:26px;">3건</div>
        </div>
        <div class="widget-content-right" style="position:absolute; right:20px;font-size:30px; top:8px; line-height:60px;">
          <div class="widget-numbers text-white"><span style="font-size:30px;font-weight:bold;">6,000,000</span></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 col-xl-3">
    <div style="text-align:right; padding:2px 10px;">전월대비 <span style="color:#0079e9;">▼ 5%</span></div>
    <div class="card mb-3 widget-content bg-grow-early" style="padding:20px; background:#444;">
      <div class="widget-content-wrapper text-white">
        <div class="widget-content-left" style="float:left;">
          <div class="widget-heading" style="font-size:26px;">10건</div>
        </div>
        <div class="widget-content-right" style="position:absolute; right:20px;font-size:30px; top:8px; line-height:60px;">
          <div class="widget-numbers text-white"><span style="font-size:30px;font-weight:bold;">10,000,000원</span></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 col-xl-3">
    <div style="text-align:right; padding:2px 10px;">전년대비 <span style="color:#0079e9;">▼ 5%</span></div>
    <div class="card mb-3 widget-content bg-grow-early" style="padding:20px; background:#444;">
      <div class="widget-content-wrapper text-white">
        <div class="widget-content-left" style="float:left;">
          <div class="widget-heading" style="font-size:26px;">20건</div>
        </div>
        <div class="widget-content-right" style="position:absolute; right:20px;font-size:30px; top:8px; line-height:60px;">
          <div class="widget-numbers text-white"><span style="font-size:30px;font-weight:bold;">20,000,000원</span></div>
        </div>
      </div>
    </div>
  </div>

</div>
    

<div style="border-top:1px solid #f0f0f0; border-bottom:1px solid #f0f0f0; margin:20px 0;">
  <input type="date" /> ~ <input type="date" /> <button class="btn btn-danger">검색</button>
</div>
          <button class="btn btn-primary btn-sm">일간</button>
          <button class="btn btn-info btn-sm">주간</button>
          <button class="btn btn-warning btn-sm">월간</button>
          <button class="btn btn-danger btn-sm">연간</button>
          <button class="btn btn-success btn-sm" style="position:absolute; right:20px;">엑셀저장</button>

<table class="table">
  <tr>
    <th>No</th>
    <th>본부</th>
    <th>신규가맹</th>
    <th>해지</th>
    <th>누적</th>
    <th>재계약율</th>
    <th>월평균 가맹</th>
    <th>비고</th>

  </tr>
  <tr>
    <td>1</td>
    <td>본사</td>
    <td>16</td>
    <td>1</td>
    <td>20</td>
    <td>100%</td>
    <td>160</td>
    <td></td>
  </tr>
  <tr>
    <th></th>
    <th>계</th>
    <th>12</th>
    <th></th>
    <th></th>
    <th></th>
    <th>150</th>
    <th>0</th>

  </tr>
</table>



      </div>
    </div>
  </div>



</template>
